'use strict';

import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Row, Col } from 'reactstrap';
import MarketingWidget from 'app/shared/components/marketing-widget/marketing-widget';
import AllowCookiesPanel from 'app/shared/components/allow-cookies-panel/allow-cookies-panel';
import GenericStep from 'app/modules/journey/ui/containers/step-generic/step-generic';
import Footer from 'app/shared/layout/footer/footer';
import { notAsked, loading, failure, success, RD, SRD } from 'srd';
import { isNull } from 'lodash';
import { buildSteps } from 'app/modules/journey/service/step.service';
import { isEndStep, nbShowStepActions } from 'app/modules/journey/service/store/step.selector';
import { AlertDanger } from 'app/shared/components/alert';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';

import './desktop-home.scss';
import { DidomiContext } from 'app/app';
import Header from 'app/shared/layout/header/header';

const DesktopHome = () => {

  const didomi = useContext(DidomiContext);

  const dispatch = useDispatch();

  const {marketingItems, productLogoUrl, spbLogoUrl} = useSelector((state: IRootState) => state.cms.marketing)
  const selectedOffer = useSelector((state: IRootState) => state.offers.selectedOffer)
  const languagesList = useSelector((state: IRootState) => state.config.languages)
  const listSteps = useSelector((state: IRootState) => state.step.journeyStepsList);
  const productCode = useSelector((state: IRootState) => state.config.productCode);
  const stepLength = useSelector(nbShowStepActions);
  const endStep = useSelector(isEndStep);

  const [desktopHomeSRD, setDesktopHomeSRD] = React.useState<RD<string, number>>(loading())
  const [isHiddenCookies, setIsHiddenCookies] = React.useState(sessionStorage.getItem('dealCookies') ? true: false);

  useEffect(() => {
    if (stepLength > 1) {
      setDesktopHomeSRD(success(0))
    }
  }, [listSteps])

  // const handleHiddenCookies = () => {
  //   setIsHiddenCookies(true);
  //   sessionStorage.setItem('dealCookies', 'true');
  //   dispatch(gtmEvent('Cookies', 'Acceptation des cookies', '0'));
  // }

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div className="app-loading"><div className="lds-dual-ring"></div></div>,
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span> :<br />{e}</span>}</AlertDanger>,
    success: (num) =>
      <div className="homeWrapper view-container">
        <Header languagesList={languagesList} />
        <Row className="homeContainer">
          <Col md={marketingItems?6:9}>
            <div className={"card jh-card hide-border background-none"}>
              {/* {!isNull(productLogoUrl) && <img className="appLogo" src={productLogoUrl} alt="" />} */}
              <GenericStep />
            </div>
          </Col>
          {marketingItems && <Col md={3}>
            <MarketingWidget marketingItems={marketingItems} />
          </Col>}
        </Row>
        <Footer didomi={didomi} spbLogoUrl={spbLogoUrl} productCode={productCode} />
      </div>
  }, desktopHomeSRD)

  return view
}


export default DesktopHome;

